const emailVerified = {
  "v-card-title": "Ups! Irgendwas lief schief",
  "v-card-text":
    "Um fortzufahren, müssen Sie Ihre E-Mail-Adresse überprüft haben. Bitte überprüfen Sie Ihren Posteingang. Wir haben Ihnen bereits eine E-Mail gesendet"
};
export default emailVerified;
